import Container from 'components/Container'
import { BlockLoader } from 'components/Loaders'
import React from 'react'

const LoadingPage = () => {
  const LOADER_HEIGHT = 300
  
  return (
    <Container>
      <BlockLoader height={LOADER_HEIGHT}/>
    </Container>
  )
}

export default LoadingPage